import get from 'lodash/get';
import set from 'lodash/set';

export const notSelectableOption = (valueKey, labelKey, label) => ({
  special: true,
  disabled: true,
  [valueKey]: `not-selectable-${Date.now()}`,
  [labelKey]: label || 'label',
});

export const SingleValue = (props) => {
  const { selectProps, data } = props;

  const labelKey = props.selectProps?.labelKey;

  const newlyCreatedLabel = data.newlyCreated && (data[labelKey] || data.name?.displayName || data.name);

  return (
    <div
      style={
        newlyCreatedLabel
          ? {
              color: '#1088e2',
              fontWeight: 'bold',
            }
          : {}
      }
    >
      {newlyCreatedLabel || selectProps.getOptionLabel(data)}
    </div>
  );
};

export const creatibleOption = (entityType, valueKey, labelKey, itemName) => {
  const option = {
    newlyCreated: true,
    [valueKey]: itemName,
    specialLabel: translate('Create new {{ entityType }} "{{ itemName }}"', {
      entityType,
      itemName,
    }),
  };
  set(option, labelKey, itemName);
  return option;
};

export const getCreatibleFilterOptions =
  (multi, valueKey, labelKey, options, entityType) => (allOptions, searchString, selectedOptions) => {
    let adjustedSelectedOptions;
    if (selectedOptions) {
      if (Array.isArray(selectedOptions)) {
        adjustedSelectedOptions = selectedOptions;
      } else {
        adjustedSelectedOptions = [selectedOptions];
      }
    } else {
      adjustedSelectedOptions = [];
    }
    const filteredOptions = allOptions.filter((item) => {
      if (multi && adjustedSelectedOptions.find((selectedOption) => selectedOption[valueKey] === item[valueKey])) {
        return false;
      }
      return item.newlyCreated || (get(item, labelKey) || '').toLowerCase().includes(searchString.toLowerCase());
    });
    if (options && searchString) {
      const sameLabelOption = options.find((item) => get(item, labelKey).toLowerCase() === searchString.toLowerCase());
      if (searchString && !sameLabelOption) {
        filteredOptions.unshift(creatibleOption(entityType, valueKey, labelKey, searchString));
      }
    }
    return filteredOptions;
  };

export const getExclude = (value, valueKey) => {
  if (Array.isArray(value)) {
    return value.map((item) => item[valueKey]).filter((itemId) => typeof itemId === 'number');
  }
  return '';
};

export const getCreatibleValueRenderer = (valueRenderer, labelKey) => (option) =>
  valueRenderer ? valueRenderer(option) : option[labelKey];

const highlightNewlyCreated = (styles, { data }) => ({
  ...styles,
  ...(data.newlyCreated
    ? {
        color: '#1088e2',
        fontWeight: 'bold',
      }
    : {}),
});

export const typeaheadStyles = {
  option: highlightNewlyCreated,
  singleValue: highlightNewlyCreated,
};
